var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.2747 12.0004L17.736 16.4617C18.088 16.8137 18.088 17.3844 17.736 17.7364C17.384 18.0884 16.8133 18.0884 16.4613 17.7364L12 13.275L7.53866 17.7364C7.18667 18.0884 6.61598 18.0884 6.26399 17.7364C5.912 17.3844 5.912 16.8137 6.26399 16.4617L10.7253 12.0004L6.26399 7.53903C5.912 7.18704 5.912 6.61635 6.26399 6.26436C6.61598 5.91237 7.18667 5.91237 7.53866 6.26436L12 10.7257L16.4613 6.26436C16.8133 5.91237 17.384 5.91237 17.736 6.26436C18.088 6.61635 18.088 7.18704 17.736 7.53903L13.2747 12.0004Z","fill":"#1D2C7F"}));
}

CloseInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
